<div class="application-confirmation-dialog">
  <mat-dialog-content>
    <form [formGroup]="formGroup">
      <div fxLayout="column" fxLayoutGap="20px">
        @if (step === 1) {
          <div fxLayout="column" fxLayoutGap="20px" class="content">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div></div>
              <div class="mat-body">Please confirm</div>
            </div>
            @for (messageAndControl of messagesAndControls; track messageAndControl.m.id) {
              <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                <mat-checkbox color="primary" [formControl]="messageAndControl.c"></mat-checkbox>
                <div class="mat-body">
                  {{messageAndControl.m.message}}
                </div>
              </div>
            }
          </div>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="center center" fxLayoutGap="20px">
            <button color="primary" (click)="onCancel($event)" mat-stroked-button>Cancel</button>
            @if (hasConsentStep) {
              <button color="primary" [disabled]="formGroup.invalid" (click)="onNext($event)" mat-flat-button>Next</button>
            } @else {
              <button color="primary" [disabled]="formGroup.invalid" (click)="onSubmit($event)" mat-flat-button>Submit</button>
            }
          </div>
        }
      </div>
    </form>

    @if (step === 2) {
      <form [formGroup]="consentFormGroup">
        <div fxLayout="column" fxLayoutGap="20px">
          <div fxLayout="column" fxLayoutGap="20px" class="content">
            <div class="mat-body">
              @if (individualsAndControls.length === 1) {
                Privacy consent and ID verification links will be sent by SMS to the following individual.
              } @else {
                Privacy consent and ID verification links will be sent by SMS to each of the following individuals.
              }
            </div>
            @for (individualAndControl of individualsAndControls; track individualAndControl.individual.id) {
              <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
                <mat-checkbox color="primary" [formControl]="individualAndControl.c"></mat-checkbox>
                <div class="mat-body">
                  {{individualAndControl.individual.firstName}} {{individualAndControl.individual.lastName}}
                </div>
              </div>
            }
            <message-box type="warn">
              Credit assessment will not begin until all individuals have completed both privacy consent and ID verification.
            </message-box>
          </div>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="center center" fxLayoutGap="20px">
            <button color="primary" (click)="onBack($event)" mat-stroked-button>Back</button>
            <button color="primary" [disabled]="consentFormGroup.invalid" (click)="onSubmit($event)" mat-flat-button>Submit</button>
          </div>
        </div>
      </form>
    }
  </mat-dialog-content>
</div>
